import { render, staticRenderFns } from "./FilterCurrentRoundOrbit.vue?vue&type=template&id=28c531bd&scoped=true"
import script from "./FilterCurrentRoundOrbit.vue?vue&type=script&lang=ts"
export * from "./FilterCurrentRoundOrbit.vue?vue&type=script&lang=ts"
import style0 from "./FilterCurrentRoundOrbit.vue?vue&type=style&index=0&id=28c531bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c531bd",
  null
  
)

export default component.exports